import React, { useState } from 'react';
import { Empty, Segmented } from 'antd';
import ErrorAnalyticsPage from '../../pages/ErrorAnalyticsPage';
import ErrorInsightsPage from '../../pages/ErrorInsightsPage';
import WindowNote from './WindowNote';

/**
 * Error analytics for the campaign, rendered by the pages that already compute
 * them: Analytics and Insights, one at a time behind a toggle, as on the
 * Evaluations tab.
 *
 * The Campaign Summary is a hub: rather than a second query for the same
 * numbers, this scopes the existing pages to the chosen campaign and window.
 * A fix there lands here, and the two cannot drift into disagreeing.
 */
export default function ErrorsTab({ campaignId, from, to }) {
  const [view, setView] = useState('analytics');
  if (!campaignId) {
    return <Empty description="Select a campaign" image={Empty.PRESENTED_IMAGE_SIMPLE} style={{ marginTop: 40 }} />;
  }
  return (
    <>
      <WindowNote from={from} to={to} />
      <Segmented
        value={view}
        onChange={setView}
        style={{ marginBottom: 16 }}
        options={[
          { label: 'Analytics', value: 'analytics' },
          { label: 'Insights',  value: 'insights' },
        ]}
      />
      {view === 'analytics' && <ErrorAnalyticsPage embedded campaignId={campaignId} from={from} to={to} />}
      {view === 'insights'  && <ErrorInsightsPage embedded campaignId={campaignId} from={from} to={to} />}
    </>
  );
}
